import { IHotel } from "@vmosolutions/oc-interfaces";
import { HotelForm } from "./HotelForm";
import { Card, CardContent, Typography } from "@mui/material";

import { IActiveModal } from "../../../Admin/AdminWindow";

interface IHotelCardProps {
  selectedHotel: IHotel;
  updateHotelList: (hotel: IHotel, mode: "create" | "update" | "delete") => void;
  setActiveModal: (activeModal: IActiveModal) => void;
}

/**
 * Main form to select hotel (to edit in HotelForm)
 */
export const HotelCard = (props: IHotelCardProps): JSX.Element => {
  const { selectedHotel, updateHotelList, setActiveModal } = props;

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" sx={{ marginBottom: "10px" }}>
          Hotel
          <span className="form_subtitle">{selectedHotel ? " Update/Delete" : " Create"}</span>
        </Typography>
        <HotelForm selectedHotel={selectedHotel} updateHotelList={updateHotelList} setActiveModal={setActiveModal} />
      </CardContent>
    </Card>
  );
};
